import React from 'react';
import clsx from 'clsx';
import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import selectorBackground from 'assets/images/counter.png';
import arrow from 'assets/images/icons/arrow.png';
import { remCalc } from 'util/style-util';
import { translate } from '../../../translations/translator';
const translateFooter = key => translate('home', key);

const PageToggleButton = ({ workbookType, handleClick, buttonClass = {} }) => {
  const classes = useStyles();
  const isTG = workbookType === 'workbook';
  const switcherTitle = translateFooter(isTG ? 'teacherGuide' : 'studentWorkbook');

  return (
    <div className={classes.buttonWrapper}>
      <div onClick={handleClick} className={clsx(classes.button, buttonClass)}>
        <img src={selectorBackground} className={classes.buttonBackground} alt={switcherTitle} />
        <Box className={classes.text}>{switcherTitle}</Box>
        <img src={arrow} className={classes.iconImage} alt={switcherTitle} />
      </div>
    </div>
  );
};

const useStyles = makeStyles(() => ({
  text: {
    color: 'black',
    marginLeft: remCalc(5),
    zIndex: 2
  },
  buttonWrapper: {
    width: remCalc(200),
    height: remCalc(60),
    marginTop: remCalc(3),
    marginRight: remCalc(10),
    position: 'relative'
  },
  buttonBackground: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    left: 0
  },
  button: {
    cursor: 'pointer',
    textAlign: 'center',
    transform: 'translateY(-5%)',
    width: 'max-content',
    height: 'max-content',
    transition: 'transform 100ms ease-in',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    padding: remCalc(20)
  },
  iconImage: {
    width: remCalc(30),
    marginLeft: remCalc(10),
    marginRight: remCalc(10),
    zIndex: 2
  }
}));

export default PageToggleButton;
